var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-data-table',_vm._b({ref:"table",attrs:{"no-data-text":"Sin prestamos.","no-search":"","remind-key":"employyee-loan-company-list"},on:{"detail":_vm.submitDetail,"remove":_vm.submitRemove}},'model-data-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }